<div>
    
      
    <!-- Main Content -->
    <div class="main-content">
        <header class="top-header">
            <h3>Edit Camera</h3>
        </header>
        
        <form class="form" [formGroup]="updateCameraForm" (ngSubmit)="onSubmit()">
            <div class="form-row">
                <div class="form-group">
                    <label>Camera ESN <small>*</small></label>
                    <input type="text" placeholder="Camera ESN" formControlName="cameraESN">
                    <div  class="error" *ngIf="updateCameraForm.get('cameraESN')?.invalid && updateCameraForm.get('cameraESN')?.touched">
                        <small *ngIf="updateCameraForm.get('cameraESN')?.errors?.['required']">Camera ESN is required.</small>
                    </div>
                </div>
                <div class="form-group">
                    <label>Organization Name <small>*</small></label>
                    <input id="organization"  formControlName="organization" readonly />
                    <!-- <div  class="error" *ngIf="updateCameraForm.get('organization')?.invalid && updateCameraForm.get('organization')?.touched">
                        <small *ngIf="updateCameraForm.get('organization')?.errors?.['required']">Organization Name is required.</small>
                    </div> -->
                </div>
                
            </div>
            <div class="form-row">
                <div class="form-group">
                    <label>Direction <small>*</small></label>
                    <select formControlName="direction" id="direction">
                        <option *ngFor="let option of directionChoice" [value]="option">{{ option }}</option>
                    </select>
                    <!-- <input type="text" placeholder="Direction" formControlName="direction"> -->
                    <div  class="error" *ngIf="updateCameraForm.get('direction')?.invalid && updateCameraForm.get('direction')?.touched">
                        <small *ngIf="updateCameraForm.get('direction')?.errors?.['required']">Direction is required.</small>
                    </div>
                </div>
                <div class="form-group">
                    <label for="description">Description <small>*</small></label>
                    <input type="text" id="description" placeholder="Description" formControlName="description">
                    <div  class="error" *ngIf="updateCameraForm.get('description')?.invalid && updateCameraForm.get('description')?.touched">
                        <small *ngIf="updateCameraForm.get('description')?.errors?.['required']">Description is required.</small>
                    </div>
                </div>
                
            </div>
            <div class="button-row">
                <button class="btn-save" type="submit">
                    <fa-icon [icon]="['fas', 'square-plus']" style="padding-right: 3px;" ></fa-icon>
                    Update
                </button>
                <button class="btn-cancel" type="button" (click)="onCancel(updateCameraForm.get('organization')?.value)">
                    <fa-icon [icon]="['fas', 'square-xmark']" style="padding-right: 3px;" ></fa-icon>
                    Cancel
                </button>
            </div>
        </form>
    </div>
</div>
